import React, { useEffect } from "react";
import FAQContent from "../function-components/FAQContent";
import {
 useAppInsightsContext,
 useTrackMetric,
 useTrackEvent,
} from "@microsoft/applicationinsights-react-js";

function FAQ() {
 const appInsights = useAppInsightsContext();
 //  useTrackMetric(appInsights, "FAQ");
 useTrackEvent(appInsights, "FAQ");

 return (
  <>
   <FAQContent />
  </>
 );
}
// added comment
export default FAQ;

//added jeevas comments 